"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EliteFitnessPerformance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="222152" id="the-future-of-ai-commerce" className="bg-background text-foreground relative min-h-[90vh] flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none z-0 overflow-hidden">
        <span className="text-[28vw] font-default font-bold text-primary/[0.04] leading-none tracking-tighter whitespace-nowrap transform translate-y-12">
          OCEAN
        </span>
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h1 className="font-default text-5xl sm:text-6xl md:text-[80px] leading-[1.0] font-bold uppercase mb-6 text-foreground drop-shadow-2xl">
          The Ocean of Commerce,
          <span className="block text-primary mt-2 sm:mt-4 font-default">
            Managed.
          </span>
        </h1>

        <p className="font-default text-base sm:text-[18px] text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
          Experience the next-generation crypto gateway. Seamless onboarding via iMessage,
          WordPress-ready checkouts, and secure OceanClaw routing for intelligent AI commerce.
        </p>

        <Button asChild size="lg" className="rounded-xl bg-foreground text-background hover:bg-foreground/90 hover:shadow-[0_0_40px_rgba(0,112,243,0.4)] transition-all duration-300 h-16 px-12 text-lg font-default uppercase tracking-wider border-none">
          <Link to="#">Download on the App Store</Link>
        </Button>
      </div>
    </section>;
}